export type LegacySystemUsagePaymentProduct = '월사용료' | '문자포인트' | '스토리지'

export interface LegacySystemUsagePaymentRow {
  id: number
  requestedAt: string
  price: number
  supply: number
  vat: number
  product: LegacySystemUsagePaymentProduct
  detail: string
  paidAt: string
  media: string
  status: string
  account: string
  receipt: string
  agency: string
}

export const legacySystemUsageGroups = ['Mock 그룹 01', 'Mock 그룹 02']

export const legacySystemUsagePaymentRows: LegacySystemUsagePaymentRow[] = [
  {
    id: 1,
    requestedAt: '2026-08-18 10:20:00',
    price: 110000,
    supply: 100000,
    vat: 10000,
    product: '월사용료',
    detail: 'Mock 월 정기 이용권',
    paidAt: '2026-08-18 10:20:03',
    media: '카드',
    status: '결제완료',
    account: '(Mock 카드) 0000-****-****-0000',
    receipt: 'Mock 영수증',
    agency: 'Mock PG',
  },
  {
    id: 2,
    requestedAt: '2026-08-12 09:15:00',
    price: 55000,
    supply: 50000,
    vat: 5000,
    product: '문자포인트',
    detail: 'Mock 문자포인트 50,000',
    paidAt: '2026-08-12 09:15:04',
    media: '카드',
    status: '결제완료',
    account: '(Mock 카드) 0000-****-****-0000',
    receipt: 'Mock 영수증',
    agency: 'Mock PG',
  },
]
